<div class="column-container section-container preference-container">
  <div class="section-title">
    {{ 'Developer Preferences' | translate }}
  </div>

  <div class="toggle-group">
    <div class="toggle-group-fields">
      <app-user-settings-permissions-toggle
        [formGroup]="form"
        [options]="{
          setting: 'hideSpaceBackLinks',
          titleText: 'Enable standalone mode' | translate,
          activeText:
            'Users are unable to leave to Spaces Manager from inside a Space. This setting overrides any query parameters in the Space URL.'
            | translate,
          inactiveText:
            'When enabled, users are unable to leave to Spaces Manager from inside a Space.'
            | translate
        }"
      >
      </app-user-settings-permissions-toggle>

      <app-user-settings-permissions-toggle
        *ngIf="isSchedulingEnabled"
        [formGroup]="form"
        [options]="{
          setting: 'preventEventEmails',
          titleText: ('Disable calendar invites via email' | translate),
          activeText:
            ('Calendar invites will not be sent automatically when an event is created, updated, or deleted inside your institution.'
            | translate),
          inactiveText:
            ('Calendar invites are sent automatically when an event is created, updated, or deleted inside your institution.'
            | translate)
        }"
      >
      </app-user-settings-permissions-toggle>
    </div>
  </div>
</div>

<div class="column-container section-container api-key-container">
  <div class="section-title">
    {{ 'API Key' | translate }}
  </div>

  <div class="column-container item">
    <div class="row-container item-header">
      <app-pencil-icon name="vpn_key" type="material-icon" [outlined]="true"></app-pencil-icon>
      <span class="item-header-text">{{
        statusMessagesMap[(generationStatus$ | async) || GenerationStatus.NotGenerated]
      }}</span>
    </div>
    <ng-container [ngSwitch]="generationStatus$ | async">
      <!-- No API Key Generated State -->
      <div class="row-container action-container" *ngSwitchCase="GenerationStatus.NotGenerated">
        <app-pencil-button
          theme="primary"
          [label]="'Generate' | translate"
          (clickEvent)="generateApiKey()"
          buttonType="button"
          icon="vpn_key"
          [iconConfig]="{ type: 'material-icon', outlined: true }"
          [showSpinner]="isActionInProgress$ | async"
          [disabled]="isActionInProgress$ | async"
        >
        </app-pencil-button>
      </div>

      <!-- Newly Generated API Key State -->
      <div class="row-container action-container" *ngSwitchCase="GenerationStatus.GeneratedNow">
        <input type="text" [value]="generatedApiKey$ | async" readonly />
        <app-pencil-button
          #copyButton
          theme="primary"
          [label]="'Copy' | translate"
          (clickEvent)="copyApiKey()"
          buttonType="button"
          [attr.tabindex]="-1"
          icon="content_copy"
          [iconConfig]="{ type: 'material-icon', outlined: true }"
        >
        </app-pencil-button>
        <ng-container *ngTemplateOutlet="revokeButton"></ng-container>
      </div>

      <!-- Existing API Key State -->
      <div class="row-container action-container" *ngSwitchCase="GenerationStatus.GenerateBefore">
        <ng-container *ngTemplateOutlet="revokeButton"></ng-container>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #revokeButton>
  <app-pencil-button
    theme="danger"
    [label]="'Revoke' | translate"
    (clickEvent)="revokeApiKey()"
    buttonType="button"
    icon="cancel"
    [iconConfig]="{ type: 'material-icon', outlined: true }"
    [showSpinner]="isActionInProgress$ | async"
    [disabled]="isActionInProgress$ | async"
  >
  </app-pencil-button>
</ng-template>
